import { PaymentAccountListItem } from '@/models/dictionary/payment-account-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PaymentAccountListState {
  paymentAccountList: PaymentAccountListItem[];
  isPaymentAccountListLoading: boolean;
}

export const usePaymentAccountListStore = defineStore({
  id: 'PaymentAccountListStore',
  state: (): PaymentAccountListState => ({
    paymentAccountList: [],
    isPaymentAccountListLoading: false,
  }),
  actions: {
    setPaymentAccountListLoading(isLoading: boolean): void {
      this.isPaymentAccountListLoading = isLoading;
    },
    getPaymentAccountList(wlSlug: string): Promise<PaymentAccountListItem[] | void> {
      if (this.paymentAccountList.length > 0) {
        return Promise.resolve(this.paymentAccountList);
      }

      this.setPaymentAccountListLoading(true);

      return api.dictionary.getPaymentAccountListRequest.perform(wlSlug)
        .then((data) => {
          this.paymentAccountList = data;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setPaymentAccountListLoading(false);
        });
    },
  },
});
